import * as React from "react";
import { observer } from "mobx-react";
import { action, observable } from "mobx";
import { hashHistory } from "react-router";
import { ILocalization } from "../../../models/localization";
import { ExperienceType, CertValidation, AddExpRoute } from "../../../models/enums";
import SeekerStore from "../../../stores/seekerStore";
import { Row, Col } from "react-flexbox-grid";
import Button from "material-ui/Button";
import * as s from "./buttons.css";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withMobileDialog,
} from 'material-ui/Dialog';

@observer
export class AddGraduationDlg extends React.Component<{ store: SeekerStore, save:()=>void }, {}> {
  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const msg: string = local.gradDlgMsg;
    return (<Dialog
      fullScreen={false}
      open={this.props.store.viewState.showAddGraduationDlg}
      aria-labelledby="responsive-dialog-title" >
      <DialogTitle id="responsive-dialog-title">{local.gradDlgHeader}</DialogTitle>
      <DialogContent>
        {msg}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => this.props.store.viewState.setShowGraduationDlg(false)} color="secondary">{this.props.store.localization.fields.cancel}</Button>
        <Button onClick={this.props.save} color="secondary">{this.props.store.localization.fields.save}</Button>
      </DialogActions>
    </Dialog>);
  }
}

@observer
export default class AddExpNavBtns extends React.Component<{ store: SeekerStore }, {}> {

  @observable openDlg: boolean;
  constructor(props: any) {
    super(props);
  }
  showGraduationDialog = (): boolean => {
    const edType: ExperienceType = this.props.store.profileStore.experienceType;
    if (edType === ExperienceType.GEDDegree && !this.props.store.profileStore.editEducation.grad) {
      this.props.store.viewState.setShowGraduationDlg(true);      
      return true;
    } else {
      return false;
    }
  }
  componentWillUnmount() {
    this.props.store.profileStore.resetValidationMode();
  }
  handleCancel = ():void => {
      this.props.store.profileStore.clearEdits();
      this.props.store.viewState.returnToLastView();
  }
  handleSaveAdd = (): void => {
    if (!this.showGraduationDialog()) {
      this.props.store.profileStore.saveExperienceEdits();     
      hashHistory.push("/profile/add-experience"); 
    }
  }

  handleSave = (): void => {
    if (!this.showGraduationDialog()) {
      this.props.store.profileStore.resetAddExpRoute();
      this.props.store.profileStore.saveExperienceEdits();
      this.props.store.viewState.returnToLastView();
    }
  }

  save = (): void => {
    this.props.store.profileStore.saveExperienceEdits();
    this.props.store.viewState.setShowGraduationDlg(false)
    this.props.store.viewState.returnToLastView();
  }

  render(): JSX.Element {
    const save: string = this.props.store.localization.fields.saveClose;
    const saveAdd: string = this.props.store.localization.fields.saveAdd;
    const cancel: string = this.props.store.localization.fields.cancel;
    const et: ExperienceType = this.props.store.profileStore.experienceType;
    const mode: CertValidation = this.props.store.profileStore.validationMode;
    const btn: any = {
      width: "100%",
    };
    let disable: boolean = false;
    if (et === ExperienceType.GEDDegree && !this.props.store.profileStore.degreeSelected) {
      disable = true;
    } else if (et === ExperienceType.Military && !this.props.store.profileStore.dateIsValid) {
      disable = true;
    } else if (et === ExperienceType.CCLC && mode === CertValidation.DateExpired && !this.props.store.profileStore.dateIsValid) {
      disable = true;
    } else if (et === ExperienceType.CCLC && mode === CertValidation.DateRecieved && !this.props.store.profileStore.dateIsValid) {
      disable = true;
    } else if (et === ExperienceType.CCLC && mode === CertValidation.FullDate && !this.props.store.profileStore.dateIsValid) {
      disable = true;
    }
    return <Row around="md">
      <Col xs={12} sm={4} md={3} lg={3} xl={2} className={s.col} > <Button style={btn} onClick={this.handleCancel} raised color="secondary" aria-label={cancel}>{cancel}</Button> </Col>
      <Col xs={12} sm={4} md={4} lg={4} xl={3} className={s.col} > <Button style={btn} disabled={disable} onClick={this.handleSaveAdd} raised color="secondary" aria-label={saveAdd}>{saveAdd}</Button></Col>
      <Col xs={12} sm={4} md={3} lg={3} xl={2} className={s.col} >  <Button style={btn} disabled={disable} onClick={this.handleSave} raised color="secondary" aria-label={save}>{save}</Button>   </Col>
      <AddGraduationDlg store={this.props.store} save={this.save} />
    </Row>
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/addEditNavBtns/index.tsx